<template>
    <span v-if="!this.published" class="ml-2 clickable">
        <fa-icon
            :icon="this.publishDate ? 'toggle-on' : 'toggle-off'"
            v-on:click="toggleActive"
        ></fa-icon>
        Autopublish:
        <span v-if="this.publishDate">
            <datetime
            	v-model="date"
            	type="datetime"
            	format="yyyy-MM-dd HH:mm"
            	class="autopublish-textbox"
    			v-on:input="changePublishDate($event)"></datetime>
        </span>
        <span v-if="!this.publishDate">Off</span>
    </span>
</template>

<script>
	import moment from 'moment-timezone';

	export default {
		props: {
			published: Boolean,
			publishDate: String,
		},
		data: function() {
			return {
				date: this._props.publishDate
					? moment.utc(this._props.publishDate).tz('Europe/Stockholm').format()
					: null,
			};
		},
		methods: {
			toggleActive: function() {
				const dateObject = moment().add(1, 'day').hours(12).startOf('hour');

				const saveDate = this._props.publishDate
					? null
					: dateObject.format('YYYY-MM-DD HH:mm');

				this.date = dateObject.format();
				this.$emit('autopublish', saveDate);
			},
			changePublishDate: function(e) {
				if (!e) return false;

				const date = moment(e).format('YYYY-MM-DD HH:mm:00');

				this.$emit('autopublish', date);
			}
		}
	};
</script>

<style>
	.autopublish-textbox {
		display: inline-block;
	}
	.autopublish-textbox input[type=text] {
		border: none;
		background: none;
		color: #3490dc;
		cursor: pointer;
	}
</style>
